import config from '../config'
import shDeleteButton from '@/components/elements/DeleteButton'
import shHoldButton from '@/components/elements/HoldButton'
import shActionButton from '@/components/elements/ActionButton'
import shTagDescription from '@/components/elements/TagDescription'
import shImageZoom from '@/components/layout/ImageZoom'

import shInputImage from '@/components/elements/InputImage'
import shProperty from '@/components/elements/Property'

export default {
  components: { shHoldButton, shDeleteButton, shInputImage, shProperty, shActionButton, shTagDescription, shImageZoom },

  data () {
    return {
      warnings: {
        telephone: 'Mobile phone if it\'s possible with Whatsapp',
        DNI: 'Identification number, just number are accepted',
        verification: 'Code verification, if you don\'t have one, go to login'
      },
      buttonText: this.fillData ? 'Update' : 'Save',
      imagePath: config.IMAGES.path,
      soundPath: config.SOUNDS.path,
      noImagePathArticle: config.IMAGES.noImagePathArticle,
      noImagePathMethod: config.IMAGES.noImagePathMethod,
      noImagePathProduct: config.IMAGES.noImagePathProduct,
      noImagePathConveyor: config.IMAGES.noImagePathConveyor,
      domain: config.DOMAIN
    }
  },
  methods: {
    playSound (sound) {
      if (sound) {
        const audio = new Audio(`${this.soundPath}/${sound}`)
        audio.play()

        return audio
      }
    },

    showLoader (show) {
      this.$store.commit('showLoader', show)
    },

    showMessage (message) {
      this.$store.commit('showMessage', message)
    },

    initForm () {
      for (const key in this.dataForm) {
        if (this.dataForm.hasOwnProperty(key)) {
          const element = this.dataForm[key]
          const isArray = Array.isArray(element)

          if (isArray) {
            this.dataForm[key] = ['']
          } else if (typeof element === 'boolean') {
            //
          } else {
            this.dataForm[key] = ''
          }
        }
      }
    },

    addInput (array, index) {
      if (!array) return
      const elementNotEmpty = array[index] !== ''
      const nextElementNotExists = index + 1 > array.length - 1

      if (elementNotEmpty && nextElementNotExists) {
        this.pushEmpty(array)
      }
    },

    pushEmpty (array) {
      this.id.push(this.i++)
      array.push('')
    },

    discard (array, index) {
      array.splice(index, 1)
      this.id.splice(index, 1)
      if (index === 0 && array.length === 0) this.pushEmpty(array)
    },

    removeSpaces (value, key) {
      if (typeof value !== 'string' || (this[key] && this[key].notRemove)) return value
      return value.replace(/\s+/g, ' ')
    },

    copyObject (obj) {
      return JSON.parse(JSON.stringify(obj))
    },

    cleanData (dataDirty) {
      const data = JSON.parse(JSON.stringify(dataDirty))
      for (const key in data) {
        const property = data[key]

        if (typeof property === 'string') {
          data[key] = this.removeSpaces(property, key)
        } else if (Array.isArray(property)) {
          const array = property

          data[key] = array.filter(data => data || data === 0 || data === false).map(data => this.removeSpaces(data))
        }
      }

      return data
    },

    deletePropertyByPath (obj, path) {
      const parts = path.split('.')
      let current = obj

      for (let i = 0; i < parts.length - 1; i++) {
        if (current == null || typeof current !== 'object') return
        current = current[parts[i]]
      }

      if (current && typeof current === 'object') {
        delete current[parts[parts.length - 1]]
      }
    },

    applyDeleteProperties (data, deleteProperties) {
      deleteProperties.forEach(property => {
        if (!property.includes('.')) {
          delete data[property]
          return
        }

        const dotIndex = property.indexOf('.')
        const parentKey = property.slice(0, dotIndex)
        const childPath = property.slice(dotIndex + 1)
        const parent = data[parentKey]

        if (parent == null) return

        if (Array.isArray(parent)) {
          parent.forEach(element => {
            if (element && typeof element === 'object') {
              this.deletePropertyByPath(element, childPath)
            }
          })
        } else if (typeof parent === 'object') {
          this.deletePropertyByPath(parent, childPath)
        }
      })
    },

    dataUpdate (originalData, newData) {
      const dataOriginal = originalData || this.cleanData(this.dataOriginal)
      const dataForm = newData || this.cleanData(this.dataForm)

      const deleteProperties = this.delete || []
      const dataUpdated = {}

      for (const key in dataOriginal) {
        const propertyOriginal = dataOriginal[key]
        const propertyForm = dataForm[key]

        if (typeof propertyOriginal === 'string') {
          console.log(propertyOriginal, propertyForm)
          if (propertyOriginal !== propertyForm.trim().toLowerCase()) {
            dataUpdated[key] = propertyForm
          }
        } else if (typeof propertyOriginal === 'boolean' || typeof propertyOriginal === 'number') {
          if (propertyOriginal !== propertyForm) {
            dataUpdated[key] = propertyForm
          }
        } else if (Array.isArray(propertyOriginal)) {
          if (Array.isArray(propertyForm)) {
            const arrayForm = propertyForm
            const arrayOriginal = propertyOriginal

            const arrayLongerLength = arrayForm.length >= arrayOriginal.length ? arrayForm.length : arrayOriginal.length

            let arrayChanged = false

            for (let index = 0; index < arrayLongerLength; index++) {
              const element = arrayForm[index]

              if (!element || element !== arrayOriginal[index]) {
                arrayChanged = true
                break
              }
            }

            if (arrayChanged && typeof arrayForm[0] === 'object') {
              arrayForm.forEach(element => {
                delete element._id
              })
            }
            if (arrayChanged) dataUpdated[key] = arrayForm
          }
        } else if (propertyOriginal === null && propertyForm) {
          const propertyForm = dataForm[key]
          dataUpdated[key] = propertyForm
        }
      }

      this.applyDeleteProperties(dataUpdated, deleteProperties)

      return JSON.stringify(dataUpdated) === '{}' ? false : dataUpdated
    },

    colorTransaction (transaction) {
      let color = ''

      if (transaction === 'create') {
        color = 'green'
      } else if (transaction === 'update') {
        color = 'blue'
      } else if (transaction === 'delete') {
        color = 'red'
      }

      return color ? `color-${color}` : ''
    },

    cutString (value, length = 15) {
      if (value.length > length) return `${value.substring(0, length)}...`

      return value
    },

    getTotals (cart) {
      const totals = { quantity: 0, priceUnit: 0, priceThree: 0, priceWholesaler: 0, priceSale: 0, priceThreeCommunity: 0, priceSaleCommunity: 0, priceSaleByUnit: 0 }
      if (!cart || !cart.length) return totals

      return cart.reduce((total, product) => {
        const quantity = product.quantityCart.reduce((a, b) => a + b, 0)
        total.quantity += quantity
        total.priceUnit += product.priceUnit * quantity
        total.priceThree += product.priceThree * quantity
        total.priceThreeCommunity += product.priceThreeCommunity * quantity
        total.priceWholesaler += product.priceWholesaler * quantity
        total.priceSale += product.priceSale * quantity
        total.priceSaleCommunity += product.priceSaleCommunity * quantity

        if (!product.isClearence) {
          total.priceSaleByUnit += product.priceUnit * quantity
        } else {
          total.priceSaleByUnit += product.priceSale * quantity
        }

        return total
      }, { quantity: 0, priceUnit: 0, priceThree: 0, priceWholesaler: 0, priceSale: 0, priceThreeCommunity: 0, priceSaleCommunity: 0, priceSaleByUnit: 0 })
    },

    getCosts (cart) {
      if (!cart || !cart.length) return 0
      const costs = cart.reduce((total, product) => {
        total += product.cost
        return total
      }, 0)

      return costs
    },

    getTotal (order, totals) {
      let total = totals.priceUnit
      if (order.isWholesaler || order.isDropshipping) {
        total = totals.priceWholesaler
      } else if (order.saleByUnit && order.isSale) {
        total = totals.priceSale
      } else if (order.saleByUnit) {
        total = totals.priceSaleByUnit
      } else if (order.isSale) {
        total = order.isCommunity ? totals.priceSaleCommunity : totals.priceSale
      } else if (totals.quantity >= (order.quantitySale || 3)) {
        total = order.isCommunity ? totals.priceThreeCommunity : totals.priceThree
      }

      return total
    },

    getDiscount (order, total) {
      if (!order.codeName) return 0
      if (order.codeType === 'percent') {
        return total * order.codePercent / 100
      } else {
        return order.codeValue
      }
    },

    getAddons (order) {
      return (order.tip || 0) + (order.methodPayCost || 0) + (order.conveyorCost || 0)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/form.js